import React from "react";
import { Spin } from "antd";

const LoadingScreen = () => {
  return <Spin fullscreen />;
};

export default LoadingScreen;
